import Dispatcher from "../dispatcher";

export default {
  bookOpened(isbn) {
    Dispatcher.emit(Dispatcher.BOOK_OPENED, isbn);
  }
};
